import { call, put } from 'redux-saga/effects';
import { ACTIONS, API_URL, STORAGE } from '../_config'
import { CallApi } from './api/callApi';


export function* getSuggestions(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URL.GLOBAL_SEARCH.GET_SUGGESTIONS, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* search(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URL.GLOBAL_SEARCH.SEARCH, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

